import { render, staticRenderFns } from "./Frontend.vue?vue&type=template&id=11c6ae4a&scoped=true"
import script from "./Frontend.vue?vue&type=script&lang=js"
export * from "./Frontend.vue?vue&type=script&lang=js"
import style0 from "./Frontend.vue?vue&type=style&index=0&id=11c6ae4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c6ae4a",
  null
  
)

export default component.exports